import React, { useCallback, useMemo, useState } from "react";

import dynamic from "next/dynamic";

import { create } from "@/src/models/basket";
import { NOTIFY } from "../../../config/api";
import { postAccount } from "@/src/models/account";
import { isLogin } from "@/src/models/loginModel";
import { LensPageDiversion } from "@/src/components/LoadAnalysis/analysis/abTest";
import stl from "./selectLenses.module.scss";
const NeckglassesModal = dynamic(import("../NeckglassesModal"));

//ga统计事件
import {
    getProductItemParams,
    productAddToCar,
    gaSelectLensBtnClick,
    gaLensPackageEvent,
    gaCommonEvent,
} from "@/src/utils/gtagEvents";
import { snapProductAddToCar } from "@/src/utils/snapEvents";
import { addToCartClickEvent } from "@/src/models/emailData";
import criteoAd from "../../../src/components/LoadAnalysis/analysis/criteo";
import {
    useCommonContext,
    usePackageInfoContext,
    useProductDetailsContext,
} from "@/src/provider";
import { signInModal } from "@/store";
import classnames from "classnames";
import { FmButton, FmDrawer, FmToast } from "@/ui-component";
import { IStyleProps } from "@/src/app/interface";
import { useTranslation } from "@/src/i18n/client";

interface Props extends IStyleProps {
    style?: any;
    pageId: number | null;
    title?: string;
}

const SelectLenses: React.FC<Props> = (props) => {
    const { style = {}, title } = props;
    const [visibleToast, setVisibleToast] = useState(false);
    const [toastType, setToastType] = useState<"info" | "loading">("info");
    const [toastChildren, setToastChildren] = useState("info");

    function hideToast() {
        setVisibleToast(true);
    }

    function showToast(msg: string) {
        setToastType("info");
        setVisibleToast(true);
        setToastChildren(msg);
    }

    function loadingToast() {
        setToastType("loading");
        setVisibleToast(true);
    }

    const [openModal] = signInModal.useSignInModalStore((state) => [
        state.openModal,
    ]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [dialogChildren, setDialogChildren] = useState("");

    const { site } = useCommonContext();
    const { t } = useTranslation(["common", "productDetail"]);

    const [
        productDetail,
        activeObj,
        changeFollow,
        changeUnderMarket,
        changeStatus,
    ] = useProductDetailsContext((state) => [
        state.productDetail,
        state.activeObj,
        state.changeFollow,
        state.changeUnderMarket,
        state.changeStatus,
    ]);
    const [
        active_package,
        usage,
        packageId,
        lensType,
        isBlue,
        isForceRx,
        packageInfoIsPackage,
    ] = usePackageInfoContext((state) => [
        state.active_package,
        state.usage,
        state.packageId,
        state.type,
        state.isBlue,
        state.isForceRx,
        state.isPackage,
    ]);
    const isPackage = useMemo(
        () => packageInfoIsPackage && productDetail.meedPackage,
        [packageInfoIsPackage, productDetail.meedPackage],
    );
    const [canNotifyClick, setCanNotifyClick] = useState(true);
    const [neckglassesModals, setNeckglassesModals] = useState(false);

    const addNotify = useCallback(() => {
        if (!canNotifyClick) {
            return;
        }
        if (activeObj.follow) {
            setDialogVisible(true);
            setDialogChildren(t("productDetail:Subscribed"));

            return;
        }

        setCanNotifyClick(false);
        postAccount(NOTIFY, {
            products_id: productDetail.products_id,
            products_color_id: activeObj.id,
        })
            .then(() => {
                setCanNotifyClick(true);
                setDialogVisible(true);
                setDialogChildren(t("productDetail:SubscribeSuccessfully"));
                changeFollow(activeObj.id!);
            })
            .catch((e) => {
                setCanNotifyClick(true);
                //产品下架
                e == 203002 && changeUnderMarket(activeObj.id!);
                //库存充足
                e == 203003 && changeStatus(activeObj.id!);

                e != 203002 && e != 203003 && showToast(e);
            });
    }, [
        activeObj.follow,
        activeObj.id,
        canNotifyClick,
        changeFollow,
        changeStatus,
        changeUnderMarket,
        productDetail.products_id,
        t,
    ]);
    //关注
    const onNotify = useCallback(() => {
        const is_login = isLogin();
        if (!is_login) {
            openModal(addNotify);
        } else {
            addNotify();
        }
    }, [addNotify, openModal]);

    //获取Ga统计参数
    const getGAStatistics = useCallback(() => {
        //根据 activeColorId 获取商品colorindex
        const showColorIdx = productDetail.products_color_relation?.findIndex(
            (item: any) => item.color_id === Number(activeObj.id),
        );
        //GA商品详情统计
        const pathName = window.location.pathname;
        return getProductItemParams({
            productList: [productDetail],
            colorIndex: showColorIdx !== -1 ? showColorIdx : 0,
            category: `pc_${pathName}`,
            list_name: `pc_${pathName}`,
        });
    }, [activeObj.id, productDetail]);

    //添加购物车
    const addCartGA = useCallback(() => {
        const sendData = getGAStatistics();
        sendData.length &&
            productAddToCar({
                items: sendData,
            });
        sendData.length &&
            snapProductAddToCar({
                items: sendData,
            });
    }, [getGAStatistics]);

    const addToCartNow = useCallback(() => {
        const data = {
            product_id: productDetail.products_id,
            color_id: activeObj.id,
            cart_quantity: 1,
            "id[2]": 300,
        };

        create(data)
            .then(() => {
                addToCartClickEvent({
                    colorId: activeObj.id,
                    price: activeObj.onsale?.price,
                });
                criteoAd.addToCart({
                    id: activeObj.id,
                    price: activeObj.onsale?.price,
                    quantity: 1,
                });
                location.href = "/basket";
            })
            .catch((e) => {
                setDialogChildren(e);
                setDialogVisible(true);
            });

        //添加GA统计
        try {
            addCartGA();
        } catch (err) {
            console.log(err);
        }
    }, [
        activeObj.id,
        activeObj.onsale?.price,
        addCartGA,
        productDetail.products_id,
    ]);

    const onNeckglasses = () => {
        setNeckglassesModals(true);
    };

    const onSelectLens = useCallback(() => {
        let _query: any = {
            lensColor: activeObj.id,
            is_package: packageId,
            products_id: productDetail.products_id,
        };
        if (props.pageId) {
            _query.page_id = props.pageId;
        }

        if (isPackage) {
            _query.is_package = packageId;
            _query.usage = usage.option_value_id ?? (isForceRx ? -1 : "");
            _query.type = lensType.option_value_id ?? "";
            _query.isBlue = isBlue ? 1 : 0;
        }
        _query.changes = "eccent";
        let isOld = LensPageDiversion({
            site,
            products_model: productDetail.products_model,
            master_categories_id: productDetail.master_categories_id,
        });

        isPackage
            ? gaLensPackageEvent(
                  "select lens",
                  active_package.name ?? "not select",
              )
            : gaSelectLensBtnClick();

        gaCommonEvent("select lens_new", {
            event_category: "lenses process",
        });
        isOld
            ? gaCommonEvent("select lens old")
            : gaCommonEvent("select lens new2");

        const queryString = Object.keys(_query)
            .map((key) => `${key}=${_query[key]}`)
            .join("&");
        location.href = isOld
            ? `/lens?${queryString}`
            : `/newlens?${queryString}`;
    }, [
        activeObj.id,
        active_package.name,
        isBlue,
        isForceRx,
        isPackage,
        lensType.option_value_id,
        packageId,
        productDetail.master_categories_id,
        productDetail.products_id,
        productDetail.products_model,
        props.pageId,
        site,
        usage.option_value_id,
    ]);

    const { p_under_market, no_rx, isNeckglasses } = productDetail;
    const { colorUnderMarket, is_notify, outOfStore } = activeObj;

    const isNotify = is_notify && !p_under_market && !colorUnderMarket;
    const caseDom = useMemo(() => {
        switch (true) {
            case p_under_market:
                return (
                    <FmButton
                        className={classnames(
                            stl["product-bottom-btn"],
                            stl["product-bottom-disable"],
                            props.className,
                        )}
                        size="large"
                        disabled
                        style={{ ...style }}
                    >
                        {t("productDetail:SOLD_OUT")}
                    </FmButton>
                );
            case colorUnderMarket:
                return (
                    <FmButton
                        style={{ ...style }}
                        className={classnames(
                            stl["product-bottom-btn"],
                            stl["product-bottom-disable"],
                            props.className,
                        )}
                        disabled
                        size="large"
                    >
                        {t("productDetail:SOLD_OUT")}
                    </FmButton>
                );
            case isNotify:
                return (
                    <FmButton
                        onClick={onNotify}
                        style={{ ...style }}
                        className={classnames(
                            stl["product-bottom-btn"],
                            props.className,
                        )}
                        size="large"
                    >
                        {t("productDetail:OUT_OF_NOTIFY")}
                    </FmButton>
                );
            case outOfStore:
                return (
                    <FmButton
                        style={style}
                        className={classnames(
                            stl["product-bottom-btn"],
                            stl["product-bottom-disable"],
                            props.className,
                        )}
                        disabled
                        size="large"
                    >
                        {t("productDetail:SOLD_OUT")}
                    </FmButton>
                );
            case no_rx:
                return (
                    <FmButton
                        style={{ ...style }}
                        onClick={addToCartNow}
                        className={classnames(
                            stl["product-bottom-btn"],
                            props.className,
                        )}
                        size="large"
                    >
                        {t("common:ADD_TO_CART")}
                    </FmButton>
                );
            case isNeckglasses:
                return (
                    <FmButton
                        onClick={onNeckglasses}
                        style={{ ...style }}
                        className={classnames(
                            stl["product-bottom-btn"],
                            props.className,
                        )}
                        size="large"
                    >
                        {t("common:ADD_TO_CART")}
                    </FmButton>
                );
            default:
                return (
                    <FmButton
                        id={`select_lenses_old`}
                        onClick={onSelectLens}
                        style={style}
                        className={classnames(
                            stl["product-bottom-btn"],
                            props.className,
                        )}
                        size="large"
                    >
                        {title ?? t("productDetail:SelectLenses")}
                    </FmButton>
                );
        }
    }, [
        addToCartNow,
        colorUnderMarket,
        isNeckglasses,
        isNotify,
        no_rx,
        onNotify,
        onSelectLens,
        outOfStore,
        p_under_market,
        props.className,
        style,
        t,
        title,
    ]);
    return (
        <>
            <FmToast type={toastType} visible={visibleToast}>
                {toastChildren}
            </FmToast>
            <FmDrawer
                open={dialogVisible}
                anchor="bottom"
                closeablePosition="right"
                closeable
                headerChildren
                footer={
                    <FmButton
                        onClick={() => {
                            setDialogVisible(false);
                        }}
                        style={{ marginTop: "0.4rem" }}
                        size="large"
                        fullWidth
                        variant="outlined"
                    >
                        {"OK"}
                    </FmButton>
                }
                onClose={() => {
                    setDialogVisible(false);
                }}
            >
                {dialogChildren}
            </FmDrawer>
            {caseDom}

            {neckglassesModals && (
                <NeckglassesModal
                    addCartGA={addCartGA}
                    color_id={activeObj.id!}
                    product_id={productDetail.products_id!}
                    pageId={props.pageId}
                    onClose={() => {
                        setNeckglassesModals(false);
                    }}
                />
            )}
        </>
    );
};

export default SelectLenses;
